import { useEffect, useState } from "react";
import GetUserInfoService from "../service/GetUserInfoService";

const useGetUserInfo = ({ onUserInfoError } = {}) => {
  const [isLoadingUserInfo, setIsLoadingUserInfo] = useState(true);
  const [userInfo, setUserInfo] = useState();

  const getUserInfoService = new GetUserInfoService();

  const fetchUserInfo = async () => {
    setIsLoadingUserInfo(true);
    try {
      const resUserInfo = await getUserInfoService.getUserInfo(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );

      if (resUserInfo.messageCode === 200001) {
        setUserInfo(resUserInfo.result);
        return;
      }
      onUserInfoError(resUserInfo.messageCode);
    } catch (e) {
      onUserInfoError(500000);
    } finally {
      setIsLoadingUserInfo(false);
    }
  };

  useEffect(() => {
    fetchUserInfo();

    return () => {
      setIsLoadingUserInfo(false);
      setUserInfo();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isLoadingUserInfo,
    userInfo,
  };
};

export default useGetUserInfo;
